import { ComponentPropsWithoutRef } from 'react'

import { radioStyles } from './RadioGroup.styles.js'

export type RadioProps = ComponentPropsWithoutRef<'span'> & {
  checked?: boolean
  disabled?: boolean
}

export function Radio({ checked = false, disabled, ...rest }: RadioProps) {
  return (
    <span
      className={radioStyles({
        checked,
        disabled,
      })}
      aria-hidden="true"
      {...rest}
    />
  )
}
